import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionService } from '../../../../../services/subscription.service';
import { PartnerSubscriptionsComponent } from '../../clinic-control-panel/partner-subscriptions/partner-subscriptions.component';
import { AccountSubscription } from '../../../../models/subscription.model';

@Component({
  selector: 'app-subscription-tool',
  templateUrl: './subscription-tool.component.html',
  styleUrls: ['./subscription-tool.component.css'],
  standalone: false,
})
export class SubscriptionToolComponent implements OnInit {
  activeSubscriptions: AccountSubscription[] = [];
  isLoading = true;

  constructor(
    private subscriptionService: SubscriptionService,
    private modalService: NgbModal,
  ) {}

  async ngOnInit() {
    await this.loadSubscriptions();
  }

  async loadSubscriptions() {
    try {
      this.activeSubscriptions = await this.subscriptionService.getActiveSubscriptions();
    } catch (error) {
      console.error('Error loading active subscriptions:', error);
    } finally {
      this.isLoading = false;
    }
  }

  get count(): number {
    return this.activeSubscriptions.filter((subscription) => subscription.plan?.isDefault !== true).length;
  }

  get isOnlyDefaultPlan(): boolean {
    return this.activeSubscriptions.length === 1 && this.activeSubscriptions[0].plan?.isDefault === true;
  }

  async onClick() {
    const modalRef = this.modalService.open(PartnerSubscriptionsComponent, {
      size: 'xl',
      backdrop: true,
      keyboard: true,
      centered: true,
      scrollable: true,
    });
    await modalRef.result.catch(() => {});
    await this.loadSubscriptions();
  }
}

